import React from "react";
import Button from "./Button";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import { motion } from "framer-motion";
import "../styles/components/Project.scss";

function Project({ image, client, title, subTitle, tags = [], liveUrl, variants, animate }) {
  return (
    <motion.div className="project-container" variants={variants} animate={animate}>
      <a
        className="image"
        href={liveUrl}
        target="_blank"
        rel="noreferrer"
        aria-label={`Open ${title} live site`}
      >
        <img src={image} alt={title} />
      </a>
      <div className="content">
        <span className="client">{client}</span>
        <div className="title">
          <a href={liveUrl} target="_blank" rel="noreferrer">
            <h3>{title}</h3>
          </a>
        </div>
        <div className="tags">
          {tags.map((tag, i) => (
            <span className="tag" key={i}>
              {tag}
            </span>
          ))}
        </div>
        <div className="subTitle">
          <p>{subTitle}</p>
        </div>
        <a href={liveUrl} target="_blank" rel="noreferrer">
          <Button
            content="Live Preview"
            color="inverse"
            icon={<HiOutlineArrowNarrowRight />}
          />
        </a>
      </div>
    </motion.div>
  );
}

export default Project;
